import * as React from 'react'
import { styled } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
// import Typography from '@mui/material/Typography'
import Badge from '@mui/material/Badge'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import { Popover, ListItemIcon, Tooltip } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import AccountCircle from '@mui/icons-material/AccountCircle'
// import MailIcon from '@mui/icons-material/Mail'
import NotificationsIcon from '@mui/icons-material/Notifications'
import LogoutIcon from '@mui/icons-material/Logout'
// import MoreIcon from '@mui/icons-material/MoreVert'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import SettingsIcon from '@mui/icons-material/Settings'
import { makeStyles } from '../hooks/makeStyles'
import { useAppSelector } from '../redux/Hook'
import { useDispatch, useSelector } from 'react-redux'
import MegaMenu from './MegaMenu'
import FullScreenButton from '../components/FullScreenButton'
import KeycloakService from '../utils/KeycloakService'
import KimsLogo from '../assets/icons/kims-logo.svg'
import { useNavigate } from 'react-router-dom'
import {
  PROFILE_ENDPOINT,
  PROFILE_ROLE_PROFILE_MAIN,
  SETTINGS_ENDPOINT,
} from '../utils/Endpoints'
import { selectUserRoles } from '../redux/reducers/UserRolesSlice'

// 🔹 Set AppBar styles
const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  boxShadow: theme.shadows[4],
  height: 48, // 👈 control AppBar height here
  display: 'flex',
  justifyContent: 'center', // keeps content vertically centered
}))

// 🔹 Set Toolbar styles
const useStyles = makeStyles((theme) => ({
  toolbar: {
    minHeight: 48, // 👈 match AppBar height
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    // display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  sectionMobile: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}))

export default function Header() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const themeDataState = useAppSelector((state) => state?.updateTheme)
  const roles = useSelector(selectUserRoles)
  const hasRole = (role: string) => roles?.includes(role)

  const [routeMenuAnchorEl, setRouteMenuAnchorEl] =
    React.useState<null | HTMLElement>(null)

  const isRouteMenuOpen = Boolean(routeMenuAnchorEl)

  const handleRouteMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setRouteMenuAnchorEl(event.currentTarget)
  }

  const handleRouteMenuClose = () => {
    setRouteMenuAnchorEl(null)
  }

  const handleSettingsClick = () => {
    navigate(SETTINGS_ENDPOINT)
  }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  // const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
  //   React.useState<null | HTMLElement>(null)

  const isMenuOpen = Boolean(anchorEl)
  // const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

  const handleThemeChange = () => {
    const newMode = themeDataState.mode === 'dark' ? 'light' : 'dark'

    dispatch({
      type: 'SAVE_THEME_DATA',
      data: {
        ...themeDataState,
        mode: newMode,
      },
    })
  }

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  // const handleMobileMenuClose = () => {
  //   setMobileMoreAnchorEl(null)
  // }

  const handleMenuClose = () => {
    setAnchorEl(null)
    // handleMobileMenuClose()
  }

  const handleLogout = () => {
    KeycloakService.doLogout()
  }

  // const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
  //   setMobileMoreAnchorEl(event.currentTarget)
  // }

  const menuId = 'primary-search-account-menu'
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {hasRole(PROFILE_ROLE_PROFILE_MAIN) && (
        <MenuItem onClick={() => navigate(PROFILE_ENDPOINT)}>
          <ListItemIcon>
            <AccountCircle fontSize='small' />
          </ListItemIcon>
          Profile
        </MenuItem>
      )}
      {/* <MenuItem onClick={handleMenuClose}>Settings</MenuItem> */}
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <LogoutIcon fontSize='small' />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  )

  // const mobileMenuId = 'primary-search-account-menu-mobile'
  // const renderMobileMenu = (
  //   <Menu
  //     anchorEl={mobileMoreAnchorEl}
  //     anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
  //     id={mobileMenuId}
  //     keepMounted
  //     transformOrigin={{ vertical: 'top', horizontal: 'right' }}
  //     open={isMobileMenuOpen}
  //     onClose={handleMobileMenuClose}
  //   >
  //     <MenuItem>
  //       <IconButton size='large' aria-label='show 4 new mails' color='inherit'>
  //         <Badge badgeContent={4} color='error'>
  //           <MailIcon />
  //         </Badge>
  //       </IconButton>
  //       <p>Messages</p>
  //     </MenuItem>
  //     <MenuItem>
  //       <IconButton
  //         size='large'
  //         aria-label='show 17 new notifications'
  //         color='inherit'
  //       >
  //         <Badge badgeContent={17} color='error'>
  //           <NotificationsIcon />
  //         </Badge>
  //       </IconButton>
  //       <p>Notifications</p>
  //     </MenuItem>
  //     <MenuItem onClick={handleProfileMenuOpen}>
  //       <IconButton
  //         size='large'
  //         aria-label='account of current user'
  //         aria-controls='primary-search-account-menu'
  //         aria-haspopup='true'
  //         color='inherit'
  //       >
  //         <AccountCircle />
  //       </IconButton>
  //       <p>Profile</p>
  //     </MenuItem>
  //   </Menu>
  // )

  const renderRouteMenu = (
    <Popover
      open={isRouteMenuOpen}
      anchorEl={routeMenuAnchorEl}
      onClose={handleRouteMenuClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <MegaMenu closeMenu={handleRouteMenuClose} />
    </Popover>
  )

  return (
    <Box>
      <StyledAppBar position='static'>
        <Toolbar className={classes.toolbar}>
          <IconButton
            size='large'
            edge='start'
            color='inherit'
            aria-label='open drawer'
            className={classes.menuButton}
            onClick={handleRouteMenuOpen}
          >
            <MenuIcon />
          </IconButton>
          <Box
            component={'img'}
            src={KimsLogo}
            alt='company-logo'
            height={48}
            width={100}
          />

          {/* <Typography
            variant='h6'
            noWrap
            component='div'
            className={classes.title}
          >
            KIMS
          </Typography> */}

          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <FullScreenButton />
            {/* <IconButton
              size='large'
              aria-label='show 4 new mails'
              color='inherit'
            >
              <Badge badgeContent={1} color='error'>
                <MailIcon />
              </Badge>
            </IconButton> */}
            <IconButton
              size='large'
              aria-label='show 17 new notifications'
              color='inherit'
            >
              <Badge badgeContent={1} color='error'>
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <Tooltip title='Settings'>
              <IconButton
                size='large'
                color='inherit'
                aria-label='settings'
                onClick={handleSettingsClick}
              >
                <SettingsIcon />
              </IconButton>
            </Tooltip>
            <IconButton onClick={handleThemeChange} color='inherit'>
              {themeDataState?.mode === 'light' ? (
                <DarkModeOutlinedIcon />
              ) : (
                <DarkModeIcon />
              )}
            </IconButton>
            <IconButton
              size='large'
              edge='end'
              aria-label='account of current user'
              aria-controls={menuId}
              aria-haspopup='true'
              onClick={handleProfileMenuOpen}
              color='inherit'
            >
              <AccountCircle />
            </IconButton>
          </div>
          {/* <div className={classes.sectionMobile}>
            <IconButton
              size='large'
              aria-label='show more'
              aria-controls={mobileMenuId}
              aria-haspopup='true'
              onClick={handleMobileMenuOpen}
              color='inherit'
            >
              <MoreIcon />
            </IconButton>
          </div> */}
        </Toolbar>
      </StyledAppBar>
      {/* {renderMobileMenu} */}
      {renderMenu}
      {renderRouteMenu}
    </Box>
  )
}
